import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-provider-preferences',
  templateUrl: './provider-preferences.component.html',
  styleUrls: ['./provider-preferences.component.css']
})
export class ProviderPreferencesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/provider/provider-preferences.component.ts